import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, PRICE } from '../data/content';
export function PricingSection() {
  return <section id="oferta" aria-labelledby="precio" className="bg-coral" data-id="element-105" data-mp="1egxjjq862e3i">
      <div className="mx-auto max-w-page px-3 py-6 text-center sm:px-6 sm:py-7" data-id="element-106" data-mp="1ja0ea1oojtla">
        <Reveal data-id="element-107" data-mp="1nb28g43qpfge">
          <h2 id="precio" className="font-display text-2xl uppercase leading-none tracking-wide text-cream sm:text-4xl" data-id="element-108" data-mp="1n9ir0a6ckyd1">
            Oferta especial — Sistema completo 6 en 1
          </h2>
          <p className="mt-1 text-[0.82rem] font-bold text-carbon sm:text-base" data-id="element-109" data-mp="1x9hwfy7h08lo">
            Comienza hoy desde las bases y avanza a tu ritmo.
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mx-auto mt-3 max-w-xl rounded-2xl border-2 border-gold bg-carbon p-3.5 sm:p-5" data-id="element-110" data-mp="2vqod34shwsc">
          <h3 className="font-display text-xl uppercase leading-none tracking-wide text-coral sm:text-3xl" data-id="element-111" data-mp="7vmtj5p83u9h">
            🔥 SISTEMA LOWER BODY 360°
          </h3>
          <p className="font-display text-lg uppercase tracking-wide text-cream sm:text-2xl" data-id="element-112" data-mp="1hodfgaauprsu">
            6 Módulos + 5 Bonos
          </p>
          <p className="mt-1.5 rounded-lg bg-gold/15 px-3 py-1 text-[0.76rem] font-extrabold uppercase text-gold sm:text-sm" data-id="element-113" data-mp="17rsa1nux6eoh">
            🎁 Bonos valorados en {BONUS_VALUE}
          </p>

          <p className="mt-2 text-[0.74rem] font-extrabold uppercase tracking-[0.18em] text-cream sm:text-sm" data-id="element-114" data-mp="25d6foiyialt9">
            🔥 Oferta especial
          </p>
          <p className="text-[0.68rem] font-bold uppercase tracking-[0.24em] text-muted sm:text-xs" data-id="element-115" data-mp="1vg1pm81ji676">
            Hoy:
          </p>
          <p className="font-impact text-5xl leading-none text-gold sm:text-6xl" data-id="element-116" data-mp="1rhu9nfewh8x1">
            {PRICE}
          </p>
          <p className="mt-1 text-[0.68rem] font-semibold uppercase tracking-wide text-muted sm:text-xs" data-id="element-117" data-mp="g0m42qsipmra">
            Pago único • Sin mensualidades • Acceso Digital
          </p>

          <div className="mt-2.5 flex flex-col items-center gap-1.5" data-id="element-118" data-mp="hfot3lr4dq58">
            <CtaButton href={CHECKOUT_URL} external size="lg" data-id="element-119" data-mp="mfjmbvydartg">
              🚀 SÍ, QUIERO EL SISTEMA COMPLETO POR {PRICE}
            </CtaButton>
            <p className="flex flex-wrap items-center justify-center gap-x-2 text-[0.66rem] font-bold uppercase tracking-wide text-muted sm:text-xs" data-id="element-120" data-mp="cioo7e60atfp">
              Acceso Inmediato
              <span aria-hidden="true" data-id="element-121" data-mp="3uul6uyv6w3jp">•</span>
              <span className="flex items-center gap-1" data-id="element-122" data-mp="3i8lw8101scf">
                <ShieldCheckIcon size={13} className="text-gold" data-id="element-123" data-mp="3jti022ypjce" />
                Garantía de 7 Días
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}